import { Recipient } from '@/domains/Business/features/Recipients/types'
import { api } from '@/lib/api'

export function getRecentRecipients() {
  return api.get<Recipient[]>(`/v1/me/beneficiaries/recent`)
}
